import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";

import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";

const TopBar = () => {
  const navigate = useNavigate();
  const [openLogout, setOpenLogout] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem("auth");
    navigate("/login");
  };

  return (
    <>
      <AppBar position="static" elevation={3}>
        <Container maxWidth="lg">
          <Toolbar sx={{ justifyContent: "space-between" }}>

            {/* LOGO */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <img
                src="/gmobiles.jpg"
                alt="G Mobiles Logo"
                style={{ height: 80 }}
              />
            </Box>

            {/* RIGHT SIDE */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 4 }}>

              {/* ADDRESS + PHONE */}
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <LocationOnIcon fontSize="small" />
                  <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                    Papparapatti, Tamil Nadu
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <PhoneIcon fontSize="small" />
                  <Typography>
                    +91 97516 15143
                  </Typography>
                </Box>
              </Box>

              {/* LOGOUT BUTTON */}
              <Button
                variant="outlined"
                color="inherit"
                startIcon={<LogoutIcon />}
                onClick={() => setOpenLogout(true)}
              >
                Logout
              </Button>

            </Box>

          </Toolbar>
        </Container>
      </AppBar>

      {/* LOGOUT CONFIRMATION POPUP */}
      <Dialog open={openLogout} onClose={() => setOpenLogout(false)}>
        <DialogTitle>Logout</DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to logout?
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenLogout(false)}>
            Cancel
          </Button>

          <Button color="error" onClick={handleLogout}>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default TopBar;
